"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Archive = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14"
}, props), _react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M0-1h16v16H0z"
}), _react.default.createElement("path", {
  className: "fill",
  d: "M1.596 8H5.09c.244 0 .471.134.606.356L6.935 10.4h2.13l1.239-2.044A.712.712 0 0 1 10.909 8h3.495l-2.32-6.125a.728.728 0 0 0-.666-.43H4.581a.727.727 0 0 0-.665.43L1.596 8zm2.986-8h6.836c.863 0 1.646.505 1.996 1.29l2.523 6.636a.719.719 0 0 1 .063.293v3.613A2.175 2.175 0 0 1 13.818 14H2.182A2.175 2.175 0 0 1 0 11.832V8.22c0-.1.021-.2.063-.293L2.586 1.29A2.182 2.182 0 0 1 4.582 0z"
})));

var _default = Archive;
exports.default = _default;